import React, {Component} from 'react';

import HeartFilled from '../../assets/images/Happily-Ever-After-Icons-Heart-filled.png';
import HeartEmpty from '../../assets/images/Happily-Ever-After-Icons-Heart.png';
import HeartFilledPink from '../../assets/images/Happily-Ever-After-Icons-Heart-filled-light-pink.png';
import HeartFilledRed from '../../assets/images/Happily-Ever-After-Icons-Heart-filled-red.png';
import HeartFilledPinkAlt from '../../assets/images/Happily-Ever-After-Icons-Heart-filled-pink-alt.png';

import './complete-tasks.scss';
import axios from "axios";
import AuthService from "../../services/authService";


class CompleteTasks extends Component {
    constructor(props) {
        super(props);
        // console.log('bring on the props: ', props)
        this.config = {
            headers: {'Authorization': "bearer " + AuthService.getToken()}
        };
        this.reviewedHeart = this.props.reviewedHeart;
        this.watchedHeart = this.props.watchedHeart;
        // console.log("CQ props", this.props);
    }

    static taskCompleted(heart) {
//<img alt="action-completed" className="heart-icon" src={HeartFilled}/>
        if (heart) {
            return (
                <div className="heart-new is_animating is_favorite"> </div>
            )
        }
        return (
            <div className="heart-box">
                <div className="heart-new"> </div>

            </div>
        )
    }

    fillHeart(e) {
        // debugger;
        // console.log('this.props', this.props);
        // console.log('reviewed', this.props.progress.reviewed, this.props.reviewedHeart);
        // If either of the first two hearts are not clicked do not allow the third heart to be clicked
        if (!this.props.reviewedHeart) {
            if (this.props.progress.watched === false || this.props.progress.reviewed === false) {
                return;
            }

        }

        // if(this.props.progress.watched === false || this.props.progress.reviewed === false){
        //     return;
        // }

        // Get the heart clicked and change it to filled
        let image = e.target;
        image.src = HeartFilled;
        this.props.fillLearnedHeart();
        // send action to API
        let dataURL = "https://onamfc.com/api/progress";
        axios.post(dataURL, {
            progress: {
                "category_id": this.props.category_id,
                "action": 'learned'
            }
        }, this.config).then(response => {
            //update the user object in local storage
            AuthService.setUser(response.data)
        });

    }

    render() {
        // console.log("Completed Tasks Props", this.props );

        return (
            <div id="complete-tasks">
                <h2>To complete this section:</h2>
                <ul className="heart-list">
                    <li>
                        <div className="heart-icon-container watched" data-tut="reactour__watch">
                            {CompleteTasks.taskCompleted(this.props.progress.watched)}
                            <p className="heart-list-text">watch video</p>
                        </div>
                    </li>
                    <li>
                        <div className="heart-icon-container reviewed" data-tut="reactour__review">
                            {CompleteTasks.taskCompleted(this.props.progress.reviewed)}
                            <p className="heart-list-text">download connecting questions</p>
                        </div>
                    </li>
                    <li>
                        <div className="heart-icon-container learned" data-tut="reactour__learn"
                             onClick={this.fillHeart.bind(this)}>
                            {CompleteTasks.taskCompleted(this.props.progress.learned)}
                            <p className="heart-list-text">we learned something new</p>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }

}

export default CompleteTasks;
